import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-3 sm:grid-cols-2 gap-6" }
const _hoisted_2 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_8 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		inject,
		ref,
		onMounted
	} from 'vue'

	
	const __default__ = { name: 'OptionDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		option: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()

	const loading = ref(true)
	const s3: any = inject('s3')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	onMounted(() => {
		// load image from s3
		try {
			const pictureField = props.option?.['job__JOBS_OPTIONS__jobID::s3JSONPicture'] ? props.option?.['job__JOBS_OPTIONS__jobID::s3JSONPicture'] : props.option?.['job__job_option__CONTACTS_OPTIONS__contactOptionsID::s3JSONPicture']
			const videoField = props.option?.['job__JOBS_OPTIONS__jobID::s3JSONVideo'] ? props.option?.['job__JOBS_OPTIONS__jobID::s3JSONVideo'] : props.option?.['job__job_option__CONTACTS_OPTIONS__contactOptionsID::s3JSONVideo']

			const photoS3Json = JSON.parse(pictureField ?? "{}")
			const photoKey = photoS3Json?.s3FilePathShortRaw
			const videoS3Json = JSON.parse(videoField ?? "{}")
			const videoKey = videoS3Json?.s3FilePathShortRaw
			
			if(photoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: photoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlPhoto.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
			if(videoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: videoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlVideo.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}

	})

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_data_display, {
        label: _unref(_localesStore).getLabel('293')
      }, {
        custom: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : (signedUrlPhoto.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "object-cover w-96 h-75 rounded-md",
                  src: signedUrlPhoto.value
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_data_display, {
        label: _unref(_localesStore).getLabel('294')
      }, {
        custom: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : (signedUrlVideo.value)
              ? (_openBlock(), _createElementBlock("video", _hoisted_8, [
                  _createElementVNode("source", {
                    type: "video/mp4",
                    src: signedUrlVideo.value
                  }, null, 8, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
}
}

})